import { yupResolver } from '@hookform/resolvers/yup'
import AOS from 'aos'
import axios from 'axios'
import { SubText, TitleH3 } from 'components/Common/Typography'
import Image from 'next/image'
import Router, { useRouter } from 'next/router'
import { ReactElement, useEffect, useState } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { SubmitHandler, useForm } from 'react-hook-form'
import { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'
import ContactForm from './ContactForm'

interface ModalProps {
  data?: any
  isOpen: boolean
  onClose: () => void
}

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}

const ContactSolutionsModal = ({
  onClose,
  isOpen,
  data,
}: ModalProps): ReactElement => {
  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')

  const router = useRouter()
  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]
  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = (dataFetch) => {
    setSuccessMesg('')
    setErrorMesg('')
    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: dataFetch.skypeID,
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }

    fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(newComment),
    })
      .then((response) => response.json())
      .then(({ code }) => {
        if (code === 200) {
          setSuccessMesg('Thank you for your message. It has been sent.')

          setTimeout(() => {
            Router.push('/thank-you')
          }, 100)
        } else {
          setErrorMesg(data.message)
        }
      })
      .catch((error) => {
        setErrorMesg('Please try again after sometime')
      })
  }

  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }
  useEffect(() => {
    fetchIpLocation()
    AOS.init()
  }, [])
  const [contactPopup, setContactPopup] = useState(false)

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      className="form_modal contact_modal_wrap Contact_solutions_modal"
      centered
    >
      <Row className="contact_modal_row">
        <Col lg={6}>
          <div className="modal_left_side_wrap">
            <div className="logo_left">
              <Image
                width={380}
                height={70}
                src="./assets/images/logo.svg"
                className="img-fluid"
                alt="Webclues Infotech"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <TitleH3
              className="mb-2 text_white"
              text="Let’s make something amazing together."
            />
            <SubText className="text_white mt-2" text="Get in touch with us." />

            <div className="links color-white">
              <a
                className="link"
                href="mailto:sales@webcluesinfotech.com"
                title="Mail"
              >
                <div className="icon">
                  <Image
                    height={17}
                    width={20}
                    src="./assets/images/mail-icon.svg"
                    alt="📨"
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">sales@webcluesinfotech.com</div>
              </a>

              <a
                className="link"
                href="skype:webcluesinfotech?chat"
                title="Skype"
              >
                <div className="icon">
                  <Image
                    height={20}
                    width={20}
                    src="./assets/images/skype-icon.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">webcluesinfotech</div>
              </a>
              <div className="link">
                <div className="icon">
                  <Image
                    height={20}
                    width={20}
                    src="./assets/images/phone-icon.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">For Sales:</div>
              </div>
              <a className="link" href="tel:+918141068282" title="Call">
                <div className="icon">
                  <Image
                    height={18}
                    width={28}
                    src="./assets/images/india-flag.svg"
                    alt="india-flag"
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">INDIA: +91-814-106-8282</div>
              </a>
              {/* <a className="link" href="tel:+19783099910" title="Call">
                <div className="icon">
                <Image
                  height={18}
                  width={28}
                    src="./assets/images/usa1.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">USA: +1-(978)-309-9910</div>
              </a> */}
              <a className="link" href="tel:+971502578857" title="Call">
                <div className="icon">
                  <Image
                    height={18}
                    width={28}
                    src="./assets/images/uae.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">UAE: +971-50-257-8857</div>
              </a>
              {/* <a className="link" href="tel:+44-776-841-8141" title="Call">
                <div className="icon">
                <Image
                  height={18}
                  width={28}
                    src="./assets/images/uk.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">UK: +44-776-841-8141</div>
              </a> */}
              {/* <a className="link" href="tel:+61480193028" title="Call">
                <div className="icon">
                <Image
                  height={18}
                  width={28}
                    src="./assets/images/aus.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">AUS: +61-480-193-028</div>
              </a> */}
              {/* <a className="link" href="tel:+16479497499" title="Call">
                <div className="icon">
                <Image
                  height={18}
                  width={28}
                    src="./assets/images/canada.svg"
                    alt=""
                    className="decoration"
                    draggable="false"
                    loading="lazy"
                  />
                </div>
                <div className="label">Canada: +1-647-949-7499</div>
              </a> */}
            </div>
          </div>
        </Col>

        <Col lg={6}>
          <Modal.Header closeButton className="border-0 pb-1" />
          <Modal.Body className="pt-0">
            <section className="contactform_new form_modal_contactform pb-0">
              <Container fluid>
                <Row className="justify-content-start">
                  <Col xl={12}>
                    <div className="logo_right">
                      <Image
                        width={380}
                        height={70}
                        src="./assets/images/logo_blue.svg"
                        className="img-fluid "
                        alt="Webclues Infotech"
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="">
                      <ContactForm />
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </Modal.Body>
        </Col>
      </Row>
    </Modal>
  )
}

export default ContactSolutionsModal
